export const SENDING_CODE = 'auth/signup/send_code';
export const SENDING_CODE_SUCCESS = 'auth/signup/send_code_success';
export const SENDING_CODE_ERROR = 'auth/signup/send_code_error';
export const LOADING = 'loading';
export const STOP_LOADING = 'stop_loading';
export const INITIAL_PATH = 'auth/INITIAL_PATH';
